var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "10px",
    viewBox: "0 0 35 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ears") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-10",
    transform: "translate(-71.000000, -61.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.4376823,61.4618128 C75.0237666,62.7259072 75.4006699,63.8443078 75.5683922,64.8170147 C75.7361146,65.7897215 75.8183895,67.4451248 75.8152171,69.7832243 L75.1258903,70.230439 C72.8214208,67.6168789 71.6691861,65.7077245 71.6691861,64.5029757 C71.6691861,63.2982269 71.7794574,62.4639017 72,62 L74.4376823,61.4618128 Z M102.433553,61.4650414 L104.457897,61.7219472 C104.994357,62.5805767 105.262588,63.6122659 105.262588,64.8170147 C105.262588,66.0217635 103.961259,67.8262383 101.358601,70.230439 L101.358601,70.230439 L100.897142,69.7496539 C100.671684,67.5869781 100.642816,66.0192868 100.810538,65.0465799 C100.97826,64.0738731 101.519265,62.8800269 102.433553,61.4650414 L102.433553,61.4650414 Z",
    id: "Ears"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEars);
export default __webpack_public_path__ + "static/media/Ears.e6c140449b8c85b192bff3eb9c15b848.svg";
export { ForwardRef as ReactComponent };